export const successFirstParagraph = 'Un ejecutivo te contactará a la brevedad';
export const successSecondParagraph = 'Evaluaremos el riesgo de tu empresa para determinar las tasas finales de cada factura.';
export const successThirdParagraph = 'Te enviaremos un correo para informarte los detalles de la operación';
